import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class NotificationService {
  @SessionStorage() public user;
  @SessionStorage() public config;

  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**Function to get notification with index value 15 in the page*/
  getNotification(pageNumber): Observable<any> {
    const data = {
      'empno': this.user.Empno,
      'role': this.user.Role,
      'pageSize': 15,
      'pageNumber': pageNumber
    };
    return this.httpService.post(`notifications`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**Function to handle error service*/  
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/common/notification/notification.service.ts